import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
// import { SvgIcon } from "../../common/SvgIcon";
import styled from "styled-components";
import { CloseOutlined } from "@ant-design/icons";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  SidebarNavLink,
  SidebarCallButton,
  Label,
  Outline,
  Span,
} from "./styles";

const HeaderCallButton = styled("button")`
  background: rgb(75, 58, 88);
  color: #fff;
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 4px;
  padding: 12px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 240px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  white-space: pre-line;
  line-height: 1.6;

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid rgb(122, 93, 163);
    background-color: rgb(122, 93, 163);
  }
`;

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        const startPosition = window.pageYOffset;
        const distance = offsetPosition - startPosition;
        const duration = 1200; // Duration in milliseconds (1.5 seconds)
        let start: number | null = null;

        const animation = (currentTime: number) => {
          if (start === null) start = currentTime;
          const timeElapsed = currentTime - start;
          const progress = Math.min(timeElapsed / duration, 1);
          
          // Easing function for smooth acceleration and deceleration
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          
          window.scrollTo(0, startPosition + distance * easeInOutCubic(progress));

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
      }
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("product")}>
          <Span>{t("Who We Are")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("services")}>
          <Span>{t("Services")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("steps")}>
          <Span>{t("Getting Started")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall
          style={{ width: "240px" }}
          onClick={() => window.location.href = "tel:(707)267-7873"}
        >
          <Span>
            <HeaderCallButton>{t("CALL (707) 267-7873\nFOR FREE CONSULTATION")}</HeaderCallButton>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  const MenuItemSidebar = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        const startPosition = window.pageYOffset;
        const distance = offsetPosition - startPosition;
        const duration = 1200; // Duration in milliseconds (1.5 seconds)
        let start: number | null = null;

        const animation = (currentTime: number) => {
          if (start === null) start = currentTime;
          const timeElapsed = currentTime - start;
          const progress = Math.min(timeElapsed / duration, 1);
          
          // Easing function for smooth acceleration and deceleration
          const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          
          window.scrollTo(0, startPosition + distance * easeInOutCubic(progress));

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
      }
      setVisibility(false);
    };
    return (
      <>
        <SidebarNavLink onClick={() => scrollTo("product")}>
          <Span>{t("Who We Are")}</Span>
        </SidebarNavLink>
        <SidebarNavLink onClick={() => scrollTo("services")}>
          <Span>{t("Services")}</Span>
        </SidebarNavLink>
        <SidebarNavLink onClick={() => scrollTo("steps")}>
          <Span>{t("Getting Started")}</Span>
        </SidebarNavLink>
        <SidebarNavLink
          onClick={() => window.location.href = "tel:(707)267-7873"}
        >
          <Span>
            <SidebarCallButton>{t("CALL (707) 267-7873\nFOR FREE CONSULTATION")}</SidebarCallButton>
          </Span>
        </SidebarNavLink>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <Row justify="space-between">
              <img src="logo.png" alt="Logo" />
              <h6>AAA Home Health Care</h6>
            </Row>
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                {/* Show CloseOutlined (X) icon only in the sidebar */}
                <CloseOutlined style={{ fontSize: 22 }} />
              </Col>
            </Label>
          </Col>
          <MenuItemSidebar />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
